export default {
    computed: {
        image () {
            return this.collection.image.url
        },
        collectionThumbnailLogo () {
            return require('assets/images/thumbnails/collection_thumbnail_logo.svg')
        },
        isImage () {
            return this.image
        }
    }
}
